import { ObjectType } from '@fullstory/proto/fs/services/dx-objects';
import { Flags } from '@fullstory/client-api';
import { defineMessage } from 'react-intl';

export const typeSupportsFeatureCard = (type: ObjectType, flags: Flags) => {
  switch (type) {
    case ObjectType.METRIC:
    case ObjectType.FUNNEL:
    case ObjectType.RETENTION:
    case ObjectType.DASHBOARD:
    case ObjectType.HEATMAP:
      return true;
    case ObjectType.SEGMENT:
      return flags.featureFlags().AppSegmentDxCards;
    case ObjectType.DATA_TABLE:
      return flags.featureFlags().AppDataTablesCards;
    default:
      return false;
  }
};

export const cannotFeatureObjectTypeMessage = defineMessage({
  defaultMessage:
    '{objectType, select, 1 {Metrics} 2 {Funnels} 3 {Retentions} 5 {Segments} 6 {Dashboards} 7 {Heatmaps} 8 {Journeys} 16 {Tables} other {object type}} cannot be featured.',
  description: 'Message that gets shown on when an object in FullStory cannot be Featured.',
  id: 'a8fwEs',
});
